function getDomTitle() {
  const regex = /^([^-]+)-?.*$/
  const title = document.title.match(regex)
  console.log(title[1])
  return title[1]
}

export { getDomTitle }
